/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum CustomerCollectionAlertStatus {
    Unknown = 0,
    Low = 1,
    Moderate = 2,
    Urgent = 3,
}
